export const LIST = 'LIST';
export const MULTI_SELECT = 'MULTI_SELECT';
export const NUMBER = 'NUMBER';
export const PRODUCT_ATTRIBUTE = 'PRODUCT_ATTRIBUTE';

export const SKU = 'SKU';
export const CATEGORY = 'CATEGORY';
